import * as CubeTree from '../../cubeTree/index';
import Utils from '../../utils/util';
import { containSubGoodsSizeByCubeId, containSubGoodsWithPosWidthSizeByCubeId } from '../goods/index';
import { textareaSize } from '../textarea/index';
import { bafflePlateSize } from '../bafflePlate/index';

function layerCubeSize(cubeId: CubeId): PhysicsSize {
    if (CubeTree.isGoods(cubeId)) {
        return containSubGoodsSizeByCubeId(cubeId);
    }
    else if (CubeTree.isTextarea(cubeId)) {
        return textareaSize(cubeId);
    }
    else {
        return bafflePlateSize(cubeId);
    }
}

function layerCubeSizeContainSpace(cubeId: CubeId): PhysicsSize {
    if (CubeTree.isGoods(cubeId)) {
        return containSubGoodsWithPosWidthSizeByCubeId(cubeId);
    }
    else if (CubeTree.isTextarea(cubeId)) {
        return textareaSize(cubeId);
    }
    else {
        return bafflePlateSize(cubeId);
    }
}

export {
    layerCubeSize,
    layerCubeSizeContainSpace
};
